import React from "react";

export default function UserActionsBar({
  mode = "module", // "hub" | "module"
  currentUser,
  onBackToModules, // module only
  onChangePassword, // hub only
  onSecurity, // hub only
  onLogout, // hub only
  extraRight, // optional, always rendered last
}) {
  const email = currentUser?.email || "";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        flexWrap: "wrap",
        justifyContent: "flex-end",
      }}
    >
      {email ? (
        <span style={{ fontSize: 13, color: "rgba(255,255,255,0.9)" }}>
          Logged in as <strong style={{ color: "#fff" }}>{email}</strong>
        </span>
      ) : null}

      {/* Module pages: ONLY back to hub */}
      {mode === "module" ? (
        <button
          className="btn-secondary"
          onClick={onBackToModules}
          disabled={!onBackToModules}
        >
          ← Back to Modules
        </button>
      ) : null}

      {/* Hub: change password, security, logout */}
      {mode === "hub" ? (
        <>
          <button className="btn-secondary" onClick={onChangePassword} disabled={!onChangePassword}>
            Change password
          </button>

          {onSecurity && (
            <button className="btn-secondary" onClick={onSecurity}>
              Security
            </button>
          )}

          <button className="btn-secondary" onClick={onLogout} disabled={!onLogout}>
            Logout
          </button>
        </>
      ) : null}

      {extraRight ? (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {extraRight}
        </div>
      ) : null}
    </div>
  );
}
